import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export default () => (
	<Switch>
		<Route path="/admin/baselaws" exact component={List} />
		<Route path="/admin/baselaws/create" component={Edit} />
		<Route path="/admin/baselaws/:id" component={Edit} />
	</Switch>
);
